import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryDownloadListDetailService = (data: any) => {
  return axiosInstance
    .get(
      `${ENDPOINTS.ADMIN.OPERATION_HISTORY.CUSTOMER_DELIVERY.READ_LIST}?${data}`,
    )
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
